module.exports = __webpack_public_path__ + "img/donante-fam.08ab62ea.png";